import React, { useEffect, useRef } from 'react'
import { Row, Col, Spin } from 'antd'
import '../../css/compliance.scss'
import * as d3 from 'd3'

const CompliancePie = (props) => {
  const ref = useRef(null)

  useEffect(() => {
    drawpiecharts()
  }, [props.data, props.index])

  var drawpiecharts = () => {
    d3.select('#piegroup' + props.index).remove()
    let svg = d3.select(ref.current)
    let count = props.data
    var label = ['complete', 'partial', 'skipped']
    var data = [
      count?.completed?.count,
      count?.partially?.count,
      count?.incomplete?.count,
    ]
    var width = 200 // new width
    var height = 200 // set equal height to form a circle
    svg.attr('width', width).attr('height', height)
    var radius = Math.min(width, height) / 2
    var g = svg
      .append('g')
      .attr('id', 'piegroup' + props.index)
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')
    var color = d3.scaleOrdinal(['#57B894', ' #FFCE70', '#F86D70'])
    var pie = d3.pie()
    var arc2 = d3.arc().innerRadius(0).outerRadius(radius)
    var arcs2 = g
      .selectAll('arc2')
      .data(pie(data))
      .enter()
      .append('g')
      .attr('stroke', 'white')
      .attr('stroke-width', '0')
      .attr('class', 'arc2')
    arcs2
      .append('path')
      .attr('fill', function (d, i) {
        return color(i)
      })
      .attr('d', arc2)
      .append('svg:title') // TITLE APPENDED HERE
      .text(function (d, i) {
        return data[i] + ' ' + label[i]
      })
  }

  const handleClick = (patientids, type) => {
    if (patientids.length > 0)
      props.fetchPatientList(patientids, props.name, type)
  }

  return (
    <Spin spinning={props.isSpin}>
      <Row flex='100%' justify='space-between' className='summary'>
        <Row justify='center' className='summary-name'>
          {props.name}
        </Row>
        <Row
          style={{ color: '#F86D70', marginTop: 20 }}
          className='summary-row'
        >
          <Col span={18} className='label'>
            Skipped
          </Col>
          <Col
            span={6}
            className='score'
            style={{ textAlign: 'end' }}
            onClick={() =>
              handleClick(props.data?.incomplete?.patientids, 'not following')
            }
          >
            {' '}
            {props.data?.incomplete?.count}
          </Col>
        </Row>
        <Row className='summary-row' style={{ color: '#FFCE70' }}>
          <Col span={18} className='label'>
            Partially Completed{' '}
          </Col>
          <Col
            span={6}
            className='score'
            style={{ textAlign: 'end' }}
            onClick={() =>
              handleClick(
                props.data?.partially?.patientids,
                'partially following'
              )
            }
          >
            {' '}
            {props.data?.partially?.count}
          </Col>
        </Row>

        <Row className='summary-row' style={{ color: '#57B894' }}>
          <Col span={18} className='label'>
            Complete{' '}
          </Col>
          <Col
            span={6}
            className='score'
            style={{ textAlign: 'end' }}
            onClick={() =>
              handleClick(
                props.data?.completed?.patientids,
                'completely followed'
              )
            }
          >
            {' '}
            {props.data?.completed?.count}
          </Col>
        </Row>
      </Row>
      <Row justify='center'>
        <svg ref={ref} width='60' height='60'></svg>
      </Row>
    </Spin>
  )
}

export default CompliancePie
